export default "__VITE_ASSET__DpQ5o5rC__"